import { useMutation, useQuery, useQueryClient } from 'react-query';
import { APIErrorType } from '../../api';
import {
  createOrder,
  CreateOrderDataType,
  fetchOrder,
  OrderType,
  payOrderFromCredit,
  PayOrderFromCreditDataType,
  updateOrderCode,
  UpdateOrderCodeDataType
} from '../../api/order';
import { UseQueryResult } from 'react-query/types/react/types';

export type useOrderReturnType = UseQueryResult<OrderType>;

export function useOrder(orderId: number | undefined): useOrderReturnType {
  if (!orderId) throw Error('orderId is undefiend');
  return useQuery<OrderType, APIErrorType>(['order', orderId], () => fetchOrder(orderId), {
    staleTime: 2 * 60 * 1000,
    retry: false
  });
}

export function useCreateOrderMutation() {
  const queryClient = useQueryClient();

  return useMutation<OrderType, APIErrorType, CreateOrderDataType>(createOrder, {
    onSuccess: order => {
      queryClient.setQueryData(['order', order.id], order);
    }
  });
}

export function usePayOrderFromCreditMutation() {
  const queryClient = useQueryClient();

  return useMutation<OrderType, APIErrorType, PayOrderFromCreditDataType>(payOrderFromCredit, {
    onSuccess: async order => {
      await queryClient.setQueryData(['order', order.id], order);
      await queryClient.invalidateQueries('exams');
    }
  });
}

export function useUpdateOrderCodeMutation() {
  const queryClient = useQueryClient();

  return useMutation<OrderType, APIErrorType, UpdateOrderCodeDataType>(updateOrderCode, {
    onSuccess: order => {
      queryClient.setQueryData(['order', order.id], order);
    }
  });
}
